module.exports = __webpack_public_path__ + "static/img/bcgtest.96d7924f.webp";